const getBackgroundImage = (piece) => {
    return `/images/${piece.color}-${piece.type}.svg`;
};
export { getBackgroundImage };
